import '@zebra-fed/icons/Enterprise/index.css';

import Snackbar from '@material-ui/core/Snackbar';
import { Button, Icon } from '@zebra-fed/zds-react-desktop';
import MaterialTable from 'material-table';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import AddUserModal from '../../components/modals/AddUserModal';
import EditManUserModal from '../../components/modals/EditManUserModal';
import ChangePasswordModal from '../../components/modals/ChangePasswordModal';
import ConfirmModal from '../../components/modals/ConfirmModal';
import firebaseUtil from '../../data/FirebaseUtil';
import { ContentWrapper, PageTitle, SnackbarContent } from '../../styled-components/shared';
import Pagination from './components/Pagination';
import { tableIcons } from './components/TableIcons';
import Toolbar from './components/Toolbar';
import { useTranslation } from "react-i18next";
import { MessageResponseContext } from "../../data/MessageLocalizationProvider";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import BottomNavLinks from '../../components/BottomNavLinks';
import { Tooltip } from "@material-ui/core";
import './manage-user.css'

import {SSOSettingsContext} from '../../authentication/SSOSettings';

const firestore = app.firestore();

const TitleText = styled.p`
  @media screen and (max-width: 750px){
    margin: 0;
    margin-bottom: 10px;
  }
`;


const MainContent = styled.div`
  // border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
  margin-top: 10px;
  @media screen and (max-width: 750px) {
    margin-top: 60px;
  }
`;

const CuzCell = styled.p`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const StyledHeader = styled(PageTitle)`
  // min-width: 1020px;
`;

/*const TableHeader = styled.h1`
  font-size: 20px;
`;*/

export default function ManageUsersPage(props) {
  const SUPER_ADMIN = 'superAdmin';
  const MANAGER = 'manager';
  const DEFAULT_ROWS_PER_PAGE = 10;
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [snackbarVisible, setSnackBarVisible] = useState(false);
  const [snackbarMessage, setSnackBarMessage] = useState('');
  const [currentUser] = useState(null);
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [deletedUser, setDeletedUser] = useState(null);
  const [deletedUserEmail, setDeletedUserEmail] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [managerData, setManagerData] = useState({});
  //const [authCode, setAuthCode] = useState('');
  const [isSSOMappingEnabled, setIsSSOMappingEnabled] = useState(false);  // DLM-21188

  const { SSOSettings, refreshSSOSettings } = useContext(SSOSettingsContext);// DLM-20746: disable SSO, "Add user" button needs to be avaiable

  const context = useContext(AuthContext);
  const modalRef = useRef();
  const addUserModalRef = useRef();
  const editManagerModalRef = useRef();

  const confirmModalRef = useRef();

  const { t } = useTranslation();

  const { getKeyItem } = useContext(MessageResponseContext);

  useEffect(() => {
    initManageUsers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function initManageUsers() {
    // find out if current user a Non-SSO or SSO user
    let companyID = context.currentUser.claims.companyID;
    console.log("initManageUsers: Getting App Settigs");
    let appSettings = (
      await firestore.collection('tenants').doc(companyID).collection('Configuration').doc('AppSettings').get()
    ).data();
    console.log("appSettings.SSOActivationStatus: "+ appSettings ? appSettings.SSOActivationStatus : "");

    if(appSettings && appSettings.SSOActivationStatus === true) {
      //console.log("initManageUsers: context.currentUser.uid: ", context.currentUser.uid);
      setLoggedInUser(context.currentUser.uid);
    } else {
      //console.log("initManageUsers: context.currentUser.email: ", context.currentUser.email);
      setLoggedInUser(context.currentUser.email);
    }

    // console.log("window.location.search : ", window.location.search);
    // const code = new URLSearchParams(window.location.search).get("code");
    // //console.log("Params : " + params);
    // console.log("AUTH CODE : " + code);
    // //setAuthCode(code);
    // firebaseUtil.getFirebaseTokenFromSSO(code).then(tokenResult => {
    //   console.log("result : " + JSON.stringify(tokenResult));
    //   //let serverResponse = JSON.parse(tokenResult);
    //   console.log("Status :", tokenResult.success);
    //   console.log("Msg :", tokenResult.msg);
    //   console.log("SSO Token : ", tokenResult.ssotoken);
    //   console.log("Firebase Token : ", tokenResult.firebasetoken);
    // }).catch(err => {
    //   console.log("Error :", err);
    // });

    // setLoggedInUser(context.currentUser.email);
    getData(pageSize);
  }

  async function getData(currentPageSize) {
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;

    // DLM-21188 - get ssoParameterMappingEnable status
    let ssoParameterMappingData = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('Configuration')
        .doc('AppSettings')
        .collection('SSOSettings')
        .doc('ssoParameterMappingEnable')
        .get()
    ).data()
    let ssoParameterMappingEnable = ssoParameterMappingData ? ssoParameterMappingData.enabled : false;
    setIsSSOMappingEnabled(ssoParameterMappingEnable);
    console.log('ManageUsersPage: getData: ssoParameterMappingEnable: ', ssoParameterMappingEnable);

    let totalCount = (
      await firestore.collection('tenants').doc(companyID).collection('TotalCounts').doc('Users').get()
    ).data().count;

    setItemCount(isSuperAdmin === true ? totalCount : totalCount - 1);
    setIsLoading(true);
    let users = [];
    if (!isSuperAdmin) {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('accessType', 'in', ['admin', 'manager'])
          .orderBy('reportedAt', 'desc')
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    } else {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .orderBy('reportedAt', 'desc')
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    }
    // console.log(users.filter(val => val.emailId == currentUserEmail));
    // console.log(users.map(val => val.emailId));
    setIsLoading(false);
    setCurrentPage(0);
    setData(users);
  }

  function onModalClose(modalType, status) {
    console.log("Add user response coming from here ", status)
    if (modalType === 'add user') {
      setError(false);
      if(status == 204)
        setSnackBarMessage(t('messages.success.successWithWarning1'));//'User added successfully'
      else
        setSnackBarMessage(t('messages.success.success5'));//'User added successfully'
      getData(pageSize);
    }
    else if(modalType === "edit_user") {
      setError(false);
      setSnackBarMessage(t('messages.success.success9'));//'User updated successfully'
      getData(pageSize);
    }
    else {
      setError(false);
      setSnackBarMessage(t('messages.success.success6'));//'Password changed successfully'
    }
    setSnackBarVisible(true);
  }

  async function next() {
    let itemsPerPage = pageSize;
    let startDoc = data[data.length - 1].reportedAt;
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;

    setIsLoading(true);
    let users = [];
    if (!isSuperAdmin) {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('accessType', 'in', ['admin', 'manager'])
          .orderBy('reportedAt', 'desc')
          .startAfter(startDoc)
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    } else {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .orderBy('reportedAt', 'desc')
          .startAfter(startDoc)
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    }
    setIsLoading(false);
    setData(users);
    setCurrentPage(currentPage + 1);
  }

  async function prev() {
    let itemsPerPage = pageSize; /* Should be fetched dynamically from UI */
    let startDoc = data[0].reportedAt; /* First user emailId from the current users list */
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;

    setIsLoading(true);
    let users = [];
    if (!isSuperAdmin) {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('accessType', 'in', ['admin', 'manager'])
          .orderBy('reportedAt', 'desc')
          .endBefore(startDoc)
          .limitToLast(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    } else {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .orderBy('reportedAt', 'desc')
          .endBefore(startDoc)
          .limitToLast(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    }

    setIsLoading(false);
    setData(users);
    setCurrentPage(currentPage - 1);
  }

  function handleDeleteUser(user) {
    setIsLoading(true);
    firebaseUtil
      .deleteUser(user, t)
      .then((response) => {
        setError(!response.status);
        setSnackBarVisible(true);
        let keyName = getKeyItem(response.msg)
        setSnackBarMessage(t(keyName));
        setDeletedUser(null);
        setDeletedUserEmail(null);
        setSearchText('');
        getData(pageSize);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(!err.status);
        setSnackBarVisible(true);
        let keyName = getKeyItem(err.msg)
        setSnackBarMessage(t(keyName));
        setDeletedUser(null);
        setDeletedUserEmail(null);
        getData(pageSize);
        setIsLoading(false);
      });
  }

  async function searchByEmailId(emailId) {
    try {
      setIsLoading(true);
      let companyID = context.currentUser.claims.companyID;
      let user = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('emailId', '==', emailId.toLowerCase())
          .get()
      ).docs.map((doc) => doc.data());
      setData(user);
      setItemCount(user.length);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setItemCount(0);
      setData([]);
    }
  }


  function onUpdateSite(siteData) {
    console.log('data onUpdateSite', data);
    console.log('siteData onUpdateSite', siteData);
    let mangerUpdatedIndex = data.findIndex((value) =>
      value.emailId === siteData.email
    )
    console.log('mangerUpdatedIndex onUpdateSite', mangerUpdatedIndex);
    let newArray = [...data]
    newArray[mangerUpdatedIndex] = { ...newArray[mangerUpdatedIndex], siteName: siteData.siteName }
    console.log(newArray,'newArray')
    setData(newArray)
  }

  console.log(data,'data')
  return (
    <>
      <ContentWrapper>
        <StyledHeader>
          <TitleText>
          {t('manageUsers')}
          </TitleText>
          <Button
            // style={{display: isSSOMappingEnabled ? "none" : "flex", margin: 0}}
            style={{display: SSOSettings.ssoLogin && isSSOMappingEnabled ? "none" : "flex", margin: 0}}
            type="primary"
            dense={true}
            // style={{ margin: 0 }}
            onClick={() => addUserModalRef.current.toggleDialog()}
          >
            {t('addUser')}
          </Button>
        </StyledHeader>
        <MainContent>
          <MaterialTable
            columns={[
              {
                cellStyle: {
                  minWidth: 100,
                  maxWidth: 100,
                },
                 title: <p className='manage-user-email'>Email</p>, field: 'emailId', sorting: false,
                render: rowData => {
                  return (<span>
                    {rowData?.emailId?.length > 10 ?
                      <Tooltip title={rowData.emailId} arrow placement="bottom-start">
                        <CuzCell className='manage-user-email'>{rowData.emailId}</CuzCell>
                      </Tooltip>
                      :
                      <p className='manage-user-email'>{rowData.emailId}</p>
                    }
                  </span>
                  )
                }
              },
              {
                cellStyle: {
                  minWidth: 100,
                  maxWidth: 100,
                },               
                title: t('userType'), field: 'authType', sorting: false,
                render: rowData =>  {
                  let userType = "Non SSO User";
                  if(rowData.authType==1){
                    userType = "SSO User"
                  }
                  return userType

                  // const unixTimestamp = rowData.checkInTime/1000;
                  // return (
                  //     <Moment format="MM/DD/YY hh:mm:ss A" unix>{unixTimestamp}</Moment>
                  // )
                }
              },
              {
                title: t('role'),
                field: 'accessType',
                searchable: false,
                cellStyle: { textTransform: 'capitalize',  minWidth: 100,
                maxWidth: 100 },
                sorting: false,
              },
              {  cellStyle: {
                minWidth: 100,
                maxWidth: 100,
              },
              title: t('siteName'), field: 'siteName', sorting: false },
            ]}
            options={{
              actionsColumnIndex: 4,
              paginationType: 'stepped',
              search: true,
              minBodyHeight: '250px',
              maxBodyHeight: '400px',
              paging: itemCount > DEFAULT_ROWS_PER_PAGE ? true : false,
              pageSize: DEFAULT_ROWS_PER_PAGE,
              pageSizeOptions: [10, 25, 50, 100],
              cspNonce: window.NONCE_ID,

            }}
            icons={tableIcons}
            isLoading={isLoading}
            actions={[
              (rowData) => ({
                hidden: rowData.accessType === SUPER_ADMIN || rowData.emailId === loggedInUser,
                icon: () => {
                  //return <Icon name={'delete'} category={'general'} color="#8e8e8e" size={18} />;
                  return <DeleteIcon />
                },
                onClick: (event, rowData) => {
                  setDeletedUser(rowData);
                  setDeletedUserEmail(rowData.emailId);
                  //deletedUserEmail = rowData.emailId;
                  console.log("Deleting:"+deletedUserEmail);
                  confirmModalRef.current.toggleDialog();
                },
                tooltip: t('deleteUser'),
              }),
              (rowData) => ({
                hidden: rowData.accessType !== MANAGER || rowData.emailId === loggedInUser,
                icon: () => {
                  //console.log(rowData, 'rowData in edit ');
                  return <EditIcon />
                },
                onClick: (event, rowData) => {
                  console.log(rowData,'rowData');
                  setManagerData({'email':rowData.emailId,'authType':rowData.authType,'siteName':rowData.siteName});
                  editManagerModalRef.current.toggleDialog();
                },
                tooltip: 'Edit',
              })
            ]}
            components={{
              Pagination: (props) => (
                <Pagination
                  {...props}
                  itemCount={itemCount}
                  currentPage={currentPage}
                  onNextClicked={next}
                  onPrevClicked={prev}
                />
              ),
              Toolbar: (props) => (
                <Toolbar
                  searchText={searchText}
                  onSearch={(searchVal) => {
                    if (searchVal !== '') {
                      setSearchText(searchVal);
                      console.log('Search ' + searchVal);
                      searchByEmailId(searchVal);
                    }
                  }}
                  onClear={(searchVal) => {
                    console.log('Reset ' + searchVal);
                    setSearchText('');
                    getData(pageSize);
                  }}
                />
              ),
            }}
            onChangeRowsPerPage={(val) => {
              setPageSize(val);
              getData(val);
            }}
            localization={{
              body: {
                emptyDataSourceMessage: t('messages.error.err26'), //"No records to display"
              },
            }}
            data={data}
          />
        </MainContent>
        <BottomNavLinks />

        <ChangePasswordModal
          modalRef={modalRef}
          currentUser={currentUser}
          onClose={() => onModalClose('change password')}
        />
        <AddUserModal modalRef={addUserModalRef} onClose={(status) => onModalClose('add user', status)} />
        <EditManUserModal
          modalRef={editManagerModalRef}
          managerDatas={managerData}
          onUpdateSite={onUpdateSite}
          onClose={() => onModalClose('edit_user')}
        />

        <ConfirmModal
          modalRef={confirmModalRef}
          title={t('deleteUser')}
          message={t('deleteUserConfirmationMsg', { deletedUserEmail })}//`Are you sure you want to delete ${deletedUser}?`
          onClose={() => {
            confirmModalRef.current.toggleDialog();
            handleDeleteUser(deletedUser);
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={snackbarVisible}
          autoHideDuration={5000}
          onClose={() => setSnackBarVisible(false)}
        >
          <SnackbarContent error={error}>{snackbarMessage}</SnackbarContent>
        </Snackbar>
      </ContentWrapper>
    </>
  );
}